import { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Dropdown, Menu, Tabs } from 'antd';
import { PlusIcon, ActionMenuIcon, EditAppointmentIcon } from 'src/icons';
import { Button } from '../../../../baseComponents';
import { SuperAdminTable } from '../../../../baseComponents/Table';
import { listPromptScreens } from 'src/modules/SuperAdmin/store/actions/promptsv2.action';
import PromptScreenModal from './PromptScreenModal';
import { PROMPT_SCREEN_SCOPES } from './promptScreenConstants';

export const PromptScreensPage = () => {
  const dispatch = useDispatch();
  const { promptScreens, promptScreensLoading } = useSelector(
    (state) => state?.promptsState
  );

  const [activeScope, setActiveScope] = useState(
    () => PROMPT_SCREEN_SCOPES[0]?.value ?? 'specialty'
  );
  const [modalOpen, setModalOpen] = useState(false);
  const [modalMode, setModalMode] = useState('create');
  const [editingRecord, setEditingRecord] = useState(null);

  useEffect(() => {
    dispatch(listPromptScreens(null, null, activeScope));
  }, [dispatch, activeScope]);

  const openCreate = () => {
    setModalMode('create');
    setEditingRecord(null);
    setModalOpen(true);
  };

  const openEdit = (record) => {
    setModalMode('edit');
    setEditingRecord(record);
    setModalOpen(true);
  };

  const menuOptions = (record) => (
    <Menu
      onClick={({ key }) => {
        if (key === 'edit') {
          openEdit(record);
        }
      }}
    >
      <Menu.Item key="edit">
        <div className="dropdown-text flex items-center space-x-2">
          <EditAppointmentIcon /> <span>Edit prompt screen</span>
        </div>
      </Menu.Item>
    </Menu>
  );

  const columns = [
    {
      title: <span className="font-[700]">Name</span>,
      dataIndex: 'prompt_screen',
      key: 'prompt_screen',
      render: (text) => text || '—',
    },
    {
      title: <span className="font-[700]">Description</span>,
      dataIndex: 'description',
      key: 'description',
      render: (text) =>
        text && text.length > 80 ? `${text.substring(0, 80)}…` : text || '—',
    },
    {
      title: 'Actions',
      key: 'actions',
      dataIndex: 'actions',
      width: 80,
      render: (_, record) => (
        <Dropdown overlay={menuOptions(record)}>
          <a className="" onClick={(e) => e.preventDefault()}>
            <ActionMenuIcon />
          </a>
        </Dropdown>
      ),
    },
  ];

  const rows = promptScreens?.prompt_screens ?? [];

  const tabItems = useMemo(
    () =>
      PROMPT_SCREEN_SCOPES.map(({ value, label }) => ({
        key: value,
        label,
        children: <span className="sr-only" />,
      })),
    []
  );

  return (
    <div className="ml-2">
      <Tabs
        activeKey={activeScope}
        onChange={setActiveScope}
        items={tabItems}
        type="line"
        className="prompt-screens-scope-tabs [&_.ant-tabs-content-holder]:hidden"
      />

      <div className="flex justify-end mb-4 mt-2">
        <Button type="button" onClick={openCreate}>
          <PlusIcon className="mr-2" /> Add
        </Button>
      </div>

      <div className="mt-2 ant-table rounded-xl shadow-xl">
        <SuperAdminTable
          className="appointment-page-table"
          data={rows}
          columns={columns}
          loading={promptScreensLoading}
          rowKey="prompt_screens_id"
          pagination={false}
        />
      </div>

      <PromptScreenModal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        mode={modalMode}
        record={editingRecord}
        scope={activeScope}
      />
    </div>
  );
};

export default PromptScreensPage;
